import { PurchaseReturnActionList, PurchaseReturnType } from "../actions/purchaseReturnAction"
import { Action } from "../actions/types"

const initialValue: Array<PurchaseReturnType> = []

const purchaseReturnReducer = (state: Array<PurchaseReturnType> = initialValue, action: Action) => {
    switch (action.type) {

        case PurchaseReturnActionList.ADD_PURCHASERETURN:
            return [
                ...state,
                action.data,
            ]

        case PurchaseReturnActionList.UPDATE_PURCHASERETURN:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case PurchaseReturnActionList.FETCH_PURCHASERETURN:
            return action.data

        case PurchaseReturnActionList.DELETE_PURCHASERETURN:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default purchaseReturnReducer